import { CKCCStatusType, ContactType, DatabaseIdTypes, EmailReminderType, MMLConnectionType, MdrCcmStatusType, MdrRpmStatusType, MiscScreenSectionId, PhoneReminderType } from "../../Enums/ChoiceEnums";
import { StringOrNothing, getObject, getText, postObject, putObject, getJson, postVoidResult, IStatusResponse, putVoid, putVoidResult } from "../ChoiceApi";
import { IChoiceEntity } from "../ChoiceEntityUtils";
import { IPatientCreateQuickInputs, IPatientCreateQuickResult, IPatientDemographicsResult, IPatientFaxQueueDeleteInputs, IPatientFaxQueueInputs, IPatientFaxQueueResults, IPatientFaxQueueSentInputs, IPatientPrintQueueAddClinicalSummaryInputs, IPatientPrintQueueDeleteInputs, IPatientPrintQueueGetClinicalSummaryInputs, IPatientPrintQueueGetClinicalSummaryResults, IPatientPrintQueueInputs, IPatientPrintQueueResults, IPatientPrintQueueUpdateClinicalSummaryInputs, IPatientTouchInputs, IPatientTouchInputsResponse, IPatientTouchInputsResult, IPatientServicePatientHeaderResponse, IPatientPrintFaxQueueInitialize, IPatientServiceAlertItem, IPatientBalanceItem, IReceiptPrefernce, IPatientEnhancedAccessItem } from "../Models/PatientModel";
import { NoTzDate } from '../DateUtils';
import { IResponsePassed } from "../Models/ResponseModel";
import { ISearchPatientInputs, ISearchPatientResults } from "../Models/SearchModel";
import { IPatientDecodeValue } from "../Models/Patient/IPatientDecodeValue";
import { IPatientSureScriptsInfo } from "../Models/Patient/IPatientSureScriptsInfo";
import { IDatabaseIdModel } from "../Models/DatabaseIdModel";


export async function entity(patientId: number): Promise<IChoiceEntity|undefined> {
    return await getObject(`api/Patient/PatientEntity/${patientId}`);
} 
export async function search(payload: ISearchPatientInputs): Promise<ISearchPatientResults|undefined> {
    return await postObject("api/Patient/Search", payload);
} 
export async function printFaxQueueInitialize(patientId: number): Promise<IPatientPrintFaxQueueInitialize|undefined> {
    return await getObject(`api/Patient/GetPrintFaxQueueInitialize/${patientId}`);
} 
export async function faxQueue(payload: IPatientFaxQueueInputs): Promise<IPatientFaxQueueResults|undefined> {
    return await postObject("api/Patient/GetFaxQueue", payload);
} 
export async function faxQueueDelete(payload: IPatientFaxQueueDeleteInputs): Promise<IResponsePassed|undefined> {
    return await postObject("api/Patient/FaxQueueDelete", payload);
} 
export async function faxQueueSent(payload: IPatientFaxQueueSentInputs): Promise<IResponsePassed|undefined> {
    return await postObject("api/Patient/FaxQueueSent", payload);
} 
export async function printQueue(payload: IPatientPrintQueueInputs): Promise<IPatientPrintQueueResults|undefined> {
    return await postObject("api/Patient/GetPrintQueue", payload);
} 
export async function addClinicalSummary(payload: IPatientPrintQueueAddClinicalSummaryInputs): Promise<IResponsePassed|undefined> {
    return await postObject("api/Patient/PrintQueueAddClinicalSummary", payload);
} 
export async function updateClinicalSummary(payload: IPatientPrintQueueUpdateClinicalSummaryInputs): Promise<IResponsePassed|undefined> {
    return await postObject("api/Patient/PrintQueueUpdateClinicalSummary", payload);
} 
export async function getClinicalSummary(payload: IPatientPrintQueueGetClinicalSummaryInputs): Promise<IPatientPrintQueueGetClinicalSummaryResults|undefined> {
    return await postObject("api/Patient/PrintQueueGetClinicalSummary", payload);
} 
export async function printQueueDelete(payload: IPatientPrintQueueDeleteInputs): Promise<IResponsePassed|undefined> {
    return await postObject("api/Patient/PrintQueueDelete", payload);
} 
export async function createQuick(payload: IPatientCreateQuickInputs): Promise<IPatientCreateQuickResult|undefined> {
    return await postObject("api/Patient/CreateQuick", payload);
} 
export async function demographics(patientId: number): Promise<IPatientDemographicsResult|undefined> {
    return await getObject(`api/Patient/Demographics/patient/${patientId}`);
}

export async function getSimpleHeader(idType: DatabaseIdTypes, patientId: number): Promise<IPatientServicePatientHeaderResponse | undefined> {
    return await getObject(`api/Patient/SimpleHeader/${idType}/${patientId}`);
}

export async function getPatientHeaderBasicInfo(id: number, idType = DatabaseIdTypes.entity_id, schedule_date?: NoTzDate): Promise<PatientHeaderBasicInfoModel|undefined>{
    return await getObject(`api/Patient/PatientHeader/BasicInfo/${idType}/${id}/${schedule_date ?? ''}`)
}

export async function getCareTeam(id: number, idType = DatabaseIdTypes.entity_id): Promise<PatientCareTeamMemberModel[]|undefined> {
    return await getObject(`api/Patient/CareTeam/${idType}/${id}`);
}

export async function getTelehealthUrl(patientId: number): Promise<StringOrNothing> {
    return await getText(`api/Patient/TelehealthUrl/${patientId}`);
}

export async function alerts(idType: DatabaseIdTypes, id: number, alertTypeId: number): Promise<IPatientServiceAlertItem[]> {
    return (await getJson(`api/Patient/Alerts/${idType}/${id}/${alertTypeId}`)) as IPatientServiceAlertItem[]
}


export async function ValidatePatient(patientEId: number, claimId: number): Promise<StringOrNothing> {
    return await getText(`api/Patient/ValidatePatient/${patientEId}/${claimId}`);
}

export async function getMiscScreenSectionsConfig(): Promise<IMiscScreenSectionInfo[]|undefined>{
    return await getObject(`api/Patient/Setup/Misc/SectionsConfig`);
}

export async function getPatientDecodeValues(patientId: number): Promise<IPatientDecodeValue|undefined>{
    return await getObject(`api/Patient/Setup/Misc/DecodeValues/${patientId}`);
}

export async function savePatientDecodeValues(data: IPatientDecodeValue): Promise<IStatusResponse>
{
    return await postVoidResult("api/Patient/Setup/Misc/DecodeValues", data);
}

export async function getPatientSureScriptsInfo(patientId: number): Promise<IPatientSureScriptsInfo|undefined>{
    return await getObject(`api/Patient/Setup/SureScriptsInfo/${patientId}`);
}

export async function updatePatientSureScriptsConsent(patientId: number, consentGiven:boolean): Promise<IPatientSureScriptsInfo|undefined>
{
    return await putObject(`api/Patient/Setup/SureScripts/Consent/${patientId}/${consentGiven}`);
}

export async function getPatientBalance(idType: DatabaseIdTypes, identifier: number): Promise<IPatientBalanceItem[]|undefined>{
    return await getObject(`api/Patient/Balance/${idType}/${identifier}`);
}

export async function getPatientReceiptPreference(patientEntityId: number): Promise<IReceiptPrefernce | undefined>{
    return await getObject(`api/Patient/ReceiptPreference/${patientEntityId}`);
}

export async function getPatientEnhancedAccessList(patientEntityId: number): Promise<IPatientEnhancedAccessItem[] | undefined>{
    return await getObject(`api/Patient/EnhancedAccessList/${patientEntityId}`);
}


// ------------------------------
// Patient Touch
export async function addPatientTouch(payload: IPatientTouchInputs): Promise<IPatientTouchInputsResponse|undefined> {
    return await postObject("api/PatientTouch/Touches", payload);
} 
export async function addPatientTouchByPatientId(patientId: number): Promise<IPatientTouchInputsResponse|undefined> {
    return await putObject(`api/PatientTouch/Touches/patient/${patientId}`); 
}
export async function getPatientTouch(): Promise<IPatientTouchInputsResult|undefined> {
    return await getObject(`api/PatientTouch/Touches`);   
}

// ------------------------------
// Patient ePA 
export async function patientEpaHistory(patientId: IDatabaseIdModel): Promise<IPatientEpaHistoryItem[]|undefined>
{
    return await getObject(`api/Patient/ePA/History/${patientId.idType}/${patientId.id}`);
}

export interface PatientHeaderBasicInfoModel
{
    patient_eid: number,
    patient_id: number,
    schedule_date?: string,
    displayName?: string,
    age?: string,
    gender?: string,
    comment_group_id?: number,
    birthDay?: NoTzDate,

    recall_reminder_id?: number,

    patientInsuranceNamePrimary?: string,
    patientInsuranceNameSecondary?: string,

    referringEntityName?: string,
    referringEntityPhone?: string,
    referringEntityFax?: string,

    practicePhysicianName?: string,
    practicePhysicianPhone?: string,
    practicePhysicianFax?: string,

    primaryCarePhysicianName?: string,
    primaryCarePhysicianPhone?: string,
    primaryCarePhysicianFax?: string,

    homePhonePrimary?: string,
    homePhoneSecondary?: string,
    businessPhonePrimary?: string,
    businessPhoneSecondary?: string,
    cellPhone?: string,
    otherPhone?: string,
    fax?: string,

    group_notes?: boolean,
    patientRoundTooltip?: string,
    patientRoundDialysisTooltip?: string,

    mmlConnectionType?: MMLConnectionType,

    ckccStatus?: CKCCStatusType,
    ckccTooltip?: string,

    
    mdrCcmStatus?: MdrCcmStatusType,
    mdrCcmDate?: NoTzDate,
    
    mdrRpmStatus?: MdrRpmStatusType,
    mdrRpmDate?: NoTzDate,
}

export interface PatientCareTeamMemberModel
{
    contactType: ContactType,
    contactTypeDesc?: string,
    name?: string,
    company?: string,
    address?: string,
    phone?: string,
    fax?: string,
    careTeamTypeDesc?: string,
    careTeamRoleDesc?: string,
    npi?: string
}

export interface IMiscScreenSectionInfo
{
    section: MiscScreenSectionId, 
    sortOrder: number, 
    isActive: boolean
}

export interface IPatientEpaHistoryItem
{
    ePATaskStatus?: string,
    drugShortName?: string,
    SIG?: string,
    startDate?: NoTzDate,
    providerName?: string,
    prescriptionId?: number,
    caseId?: string
}